/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_register_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Snadná a bezplatná registrace!`
};

const da_account_register_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Nem og gratis tilmelding!`
};

const de_account_register_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Schnelle und kostenlose Registrierung!`
};

const en_account_register_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Registration is free and easy!`
};

const es_account_register_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `¡Registro fácil y gratuito!`
};

const fr_account_register_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Inscription facile et gratuite !`
};

const hu_account_register_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Könnyű és ingyenes regisztráció!`
};

const it_account_register_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Registrazione facile e gratuita!`
};

const nl_account_register_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Snel en gratis registreren!`
};

const pl_account_register_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Rejestracja jest szybka i darmowa!`
};

const pt_account_register_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Cadastro fácil e gratuito!`
};

const sv_account_register_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Enkel och gratis registrering!`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_register_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_register_subtitle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_register_subtitle", locale)
	if (locale === "cs") return cs_account_register_subtitle(inputs)
	if (locale === "da") return da_account_register_subtitle(inputs)
	if (locale === "de") return de_account_register_subtitle(inputs)
	if (locale === "en") return en_account_register_subtitle(inputs)
	if (locale === "es") return es_account_register_subtitle(inputs)
	if (locale === "fr") return fr_account_register_subtitle(inputs)
	if (locale === "hu") return hu_account_register_subtitle(inputs)
	if (locale === "it") return it_account_register_subtitle(inputs)
	if (locale === "nl") return nl_account_register_subtitle(inputs)
	if (locale === "pl") return pl_account_register_subtitle(inputs)
	if (locale === "pt") return pt_account_register_subtitle(inputs)
	return sv_account_register_subtitle(inputs)
};
export { account_register_subtitle as "account.register_subtitle" }